import InfoCard from "./InfoCard";

const Educommittee = () => {
  return (
    <div className="p-6 md:p-12 max-w-[95%] mx-auto text-tertiary">
      {/* Title Section */}
      <h1 className="text-2xl md:text-4xl font-bold text-center mb-4">
        बीकानेर प्रौढ़ शिक्षण समिति, बीकानेर
      </h1>
      <p className="text-center text-lg md:text-xl mb-8">
        एक स्वैच्छिक संस्था जो शिक्षा, स्वास्थ्य एवं रोजगार सृजन के क्षेत्र में कार्यरत है
      </p>

      {/* Main Content */}
      <div className="space-y-6">
        {/* 1 */}
        <div className="border border-tertiary bg-secondary-light flex flex-col gap-8 p-4 rounded-xl">

          <div>
            <h1 className='text-2xl font-semibold'>संस्था का परिचय:</h1>
            <p className="indent-8 pb-1">
              बीकानेर प्रौढ़ शिक्षण समिति की स्थापना वर्ष 1965 में समाज के वंचित वर्ग के संघठन के उद्देश्यों को लेकर हुई। इसका मुख्य उद्देश्य मानवीय एवं नैतिक आधार पर एक समतामूलक जागरूक समाज की स्थापना करना था। सामाजिक, सांस्कृतिक एवं आर्थिक स्तर पर एक सशक्त समाज की कल्पना को साकार करने में आज 57 वर्षों से अधिक समय से निरंतर संचालित हो रही है। यह संस्था राजस्थान की अत्यंत प्राचीन कुछ स्वयंसेवी संस्थाओं में से एक है जो अब तक निरंतर सक्रिय है।
            </p>
            <p className="indent-8 pb-1">
                बीकानेर जिले में संस्था द्वारा अब तक किए गए कार्यों का काफी लंबा इतिहास रहा है। जिसके तहत संस्था ने तीन महत्वपूर्ण आयामों - शिक्षा, स्वास्थ्य एवं रोजगार सृजन पर विशेष कार्य किए हैं। नियमित कार्यों के साथ-साथ राष्ट्रीय एवं सामाजिक सरोकार की गतिविधियों एवं कार्यक्रमों के माध्यम से जन चेतना के भी प्रभावी कार्य निरंतर किए जा रहे हैं। संस्था द्वारा राज्य एवं राष्ट्रीय स्तर की शिक्षा, स्वास्थ्य एवं रोजगार विकास से जुड़ी विभिन्न परियोजनाओं का प्रभावी रूप से जमीनी स्तर पर संचालन किया गया है।
            </p>
            <p className="indent-8">
              समिति शिक्षा विभाग, राजस्थान सरकार की एक विशेष स्तर की मान्यता प्राप्त संस्था है। समिति के कार्यों से प्रभावित होकर दिनांक 15 सितम्बर, 1968 से सरकार ने इसे एक विशेष मान्यता का दर्जा दे दिया। इसके साथ ही संस्था को शिक्षा विभाग की ओर से 80 प्रतिशत अनुदान भी प्राप्त था। यह एक ऐतिहासिक उपलब्धि थी। गैर सरकारी संगठनों के इतिहास में बीकानेर प्रौढ़ शिक्षण समिति पहली और संभवतः अंतिम गैर सरकारी संगठन है जो शिक्षा विभाग से प्रौढ़ शिक्षा के क्षेत्र में स्थायी मान्यता के साथ 80 प्रतिशत अनुदान निरंतर प्राप्त हुआ। राजस्थान सरकार के निर्णयानुसार वर्ष 2015 के बाद वर्तमान में अनुदान बंद हो गया है, लेकिन संस्था को विशेष स्तर की मान्यता अब भी प्राप्त है।
            </p>

          <div className="pl-8">
            <h1 className='text-lg font-semibold pt-4'>संस्था की दृष्टि (Vision):</h1>
            <ul className="list-disc pl-5">
              <li>मानवीय एवं नैतिक धरातल पर समतामूलक जागृत समाज की रचना करना|</li>
            </ul>
          
            <h1 className='text-lg font-semibold pt-4'>संस्था का ध्येय (Mission):</h1>
            <ul className="list-disc pl-5 space-y-2">
              <li>शैक्षिक, आर्थिक एवं सामाजिक दृष्टि से पिछडे लोगों के उत्थान के लिये कार्य करना|</li>
              <li>साक्षरता एवं सतत शिक्षा की निरन्तरता को बनाये रखते हुये शिक्षा विकास की गतिविधियों का क्रियान्वयन|</li>
              <li>महिलाओं एवं बच्चों के स्वास्थ्य एवं सशक्तिकरण का क्रियान्वयन करते हुए लिंग भेद को समानता प्रदान कर कौशलोन्मुख बनाना</li>
              <li>रोजगारोन्मुख प्रशिक्षणों का आयोजन कर समाज के पिछड़े वर्ग को आत्मनिर्भर एवं स्वावलंबी बनाना</li>
            </ul>
            </div>
          </div>

        <InfoCard title="संस्था के उद्देश्य:">
          <ul className="list-disc pl-5 space-y-3">
            <li>शैक्षिक दृष्टि से पिछड़े युवक-युवतियों को साक्षरता से लेकर निरंतर शिक्षा तक जोड़ने का कार्य करना एवं प्राथमिक शिक्षा से वंचित बालिकाओं एवं बालकों को शिक्षा की मुख्य धारा से जोड़कर शैक्षिक सशक्तिकरण प्रदान करना</li>
            <li>स्वास्थ्य के प्रति जन जागरूकता बढ़ाने हेतु लक्ष्य समूह को स्वास्थ्य एवं आरोग्य संबंधी प्रक्रियाओं का ज्ञान कराना</li>
            <li>बेरोजगार एवं जरूरतमंद युवक-युवतियों को बाजार की मांग के अनुरूप व्यावसायिक कौशल प्रशिक्षण देकर उन्हें आर्थिक रूप से स्वावलंबी बनाना</li>
            <li>ग्रामीण एवं शहरी क्षेत्रों में पढ़ने की आदतों के विकास हेतु पुस्तकालय, वाचनालय, पाठशाला आदि का संचालन करना</li>
            <li>पर्यावरण एवं अन्य विकास योजनाओं से आमजन को परिचित कराना एवं संबंधित विषयों पर विभिन्न परियोजनाओं का संचालन करना</li>
            <li>लक्ष्य समूह के सामाजिक एवं सांस्कृतिक स्तर को मानवीय व नैतिक आधार पर गतिशील बनाना</li>
            <li>उपरोक्त उद्देश्यों के अतिरिक्त भी सामाजिक विकास के लिए संस्था सदैव तत्पर रहती है</li>
          </ul>
        </InfoCard>

        <InfoCard title="संस्था का कार्य विवरणः">
          <ul className="list-disc pl-5">
            <li>जन भागीदारी से साक्षरता एवं निरंतर शिक्षा हेतु निरंतर कार्य किया जाता है</li>
            <li>प्राथमिक शिक्षा के सार्वभौमीकरण हेतु वंचित वर्गों की बालिकाओं एवं बालकों को शिक्षा की मूल अवधारणा से जोड़ना</li>
            <li>महिला विकास के महत्वपूर्ण एवं प्रत्यक्ष कार्यक्रमों की पहचान कर उन्हें गति प्रदान करना। महिलाओं में सामाजिक, राजनीतिक, आर्थिक मुद्दों पर समझ पैदा करना</li>
            <li>युग की आवश्यकतानुसार व्यवसायों में प्रशिक्षण देना और कुशल बनने की सुविधा प्रदान करना</li>
            <li>लोक एवं उपयोगी कला-कौशल, हस्तशिल्प आदि के प्रशिक्षण देना</li>
            <li>स्वास्थ्य एवं आरोग्य संबंधी आधुनिक प्रक्रियाओं का ज्ञान कराना</li>
            <li>सांस्कृतिक एवं सामाजिक स्तर को मानवीय, वैज्ञानिक एवं नैतिक आधार पर गतिशील बनाना</li>
            <li>साक्षरता केन्द्रों एवं स्थानीय विद्यालयों में नामांकन-उपस्थिति एवं शिक्षा की गुणवत्ता हेतु कार्य करना</li>
            <li>ग्रामीण एवं शहरी क्षेत्रों में पढ़ने की आदतों के विकास हेतु पुस्तकालय, वाचनालय एवं एसवीएम साइकिल का संचालन करना</li>
            <li>शिक्षक-पर्यवेक्षक प्रशिक्षण एवं सहायक सामग्री निर्माण कार्यशाला समय-समय पर आयोजित करना</li>
            <li>बालिका शिक्षा को बढ़ावा देने हेतु समय-समय पर आवासीय बालिका शिक्षण शिविर संचालित करना</li>
            <li>ग्रामीण-शहरी क्षेत्र में लघु उद्योग, रोजगार प्रशिक्षण, कौशल शिक्षण, हस्तकलाएं, पर्यावरण एवं अन्य विकास योजनाओं से परिचित कराना एवं विभिन्न ग्रामीण विकास परियोजनाओं का संचालन कराना</li>
            <li>हस्तशिल्प एवं साक्षरता केन्द्रों के माध्यम से महिला स्वावलंबन, कलात्मक रुचियों की अभिव्यक्ति, प्रतिभा निखार आदि से महिलाओं की भागीदारी सुनिश्चित करना</li>
            <li>व्यावहारिक शिक्षा से जुड़े विभिन्न आयामों जिसमें कृषि, पशुपालन, उन्नत बीज, उर्वरक सुधार, कम्पोस्ट खाद, जनसंख्या शिक्षा, पंचायती राज, महिला अधिकार, जेंडर क्षमता आदि में संस्था जन चेतना जगाने में कार्यरत है</li>
            <li>सूचना संग्रह, संप्रेषण एवं जानकारी स्रोत हेतु इकाई के रूप में कार्य करना</li>
            <li>साक्षरता, उत्तर साक्षरता एवं निरंतर शिक्षा हेतु नवसाक्षरोपयोगी साहित्य उपलब्ध कराना</li>
            <li>राष्ट्रीय समस्याओं के प्रति जन जागृति पैदा करना</li>
          </ul>
        </InfoCard>

        <InfoCard title="संस्था की मुख्य उपलब्धियां:">
          <div className="space-y-6">
            <div>
              <h3 className="font-semibold">1. नेहरू साक्षरता पुरस्कार 1995:</h3>
              <p>साक्षरता के क्षेत्र में देश का सर्वोच्च नेहरू साक्षरता पुरस्कार संस्था के पूर्व अध्यक्ष श्री सत्यनारायण पारीक को प्राप्त हुआ।</p>
            </div>
            
            <div>
              <h3 className="font-semibold">2. लूणकरणसर तहसील में सम्पूर्ण साक्षरता अभियान:</h3>
              <p>संस्था द्वारा बीकानेर जिले की लूणकरणसर तहसील के समस्त 144 गाँवों में 15-35 आयुवर्ग के 55000 प्रौढ़ों को साक्षर करने का अद्वितीय एवं प्रशंसनीय कार्य किया गया। यह कार्य देश-प्रदेशों में स्वैच्छिक संस्था द्वारा सम्पूर्ण साक्षरता अभियान में पहला प्रयास रहा। यह कार्य मानव संसाधन विकास मंत्रालय, नई दिल्ली के सहयोग से संचालित किया गया।</p>
            </div>
            
            <div>
              <h3 className="font-semibold">3. साक्षरता के क्षेत्र में उत्कृष्ट कार्य के लिए 5 लाख रुपये का पुरस्कार:</h3>
              <p>बीकानेर जिले में लूणकरणसर तहसील में साक्षरता के क्षेत्र में उत्कृष्ट कार्य हेतु राज्य सरकार द्वारा 5 लाख रुपये की राशि पुरस्कार स्वरूप प्रदान की गई, जिसका उपयोग पंचायत समिति लूणकरणसर के माध्यम से ग्रामीण क्षेत्रों में पीने के पानी की व्यवस्था हेतु किया गया।</p>
            </div>
            
            <div>
              <h3 className="font-semibold">4. नवसाक्षर एवं बालोपयोगी साहित्य का प्रकाशन:</h3>
              <p>संस्था द्वारा सरल एवं सहज भाषा में विभिन्न विषयों पर नवसाक्षरों एवं बालोपयोगी 61 पुस्तकों का प्रकाशन किया जा चुका है। प्रकाशित साहित्य उत्तर साक्षरता, निरंतर शिक्षा एवं अनौपचारिक शिक्षा के लिए उपयोगी सिद्ध हुआ है।</p>
            </div>
            
            <div>
              <h3 className="font-semibold">5. मान्यता प्राप्त पुस्तकालय, वाचनालय एवं एसवीएम साइकिल का संचालन:</h3>
              <p>संस्था में 1 फरवरी 1987 से मान्यता प्राप्त एक पुस्तकालय संचालित है। जिसमें विभिन्न विषयों की लगभग 20,000 पुस्तकें उपलब्ध हैं। जिसका उपयोग विभिन्न शोधार्थियों द्वारा समय-समय पर किया जाता रहा है। पढ़ने की आदतों के विकास हेतु ग्रामीण एवं शहरी क्षेत्रों में विभिन्न पुस्तकालय, वाचनालय एवं एसवीएम साइकिल के माध्यम से संस्था सक्रिय कार्य कर रही है।</p>
            </div>
            
            <div>
              <h3 className="font-semibold">6. आर्थिक स्वावलंबन का प्रभावी कार्य:</h3>
              <p>आर्थिक दृष्टि से पिछड़े एवं वंचित लोगों को आत्मनिर्भर एवं आर्थिक स्वावलंबन बढ़ाने हेतु संस्था द्वारा संचालित विभिन्न परियोजनाओं एवं स्वयं के आर्थिक प्रयासों से विभिन्न व्यावसायिक कौशल प्रशिक्षण संचालित किए जाते रहे हैं।</p>
            </div>
            
            <div>
              <h3 className="font-semibold">7. संस्था में हुनर हाट की स्थापना:</h3>
              <p>संस्था द्वारा नगर निगम, बीकानेर के आर्थिक सहयोग से संस्था परिसर में हुनर हाट की स्थापना की गई है। इस हाट में संस्था स्तर पर विभिन्न व्यवसायों में प्रशिक्षण प्राप्त प्रशिक्षुओं द्वारा तैयार उत्पाद को स्थायी रूप से निरंतर बाजार से जोड़ने की व्यवस्था की गई है। जहाँ वे अपना तैयार उत्पाद बेचते हैं और उसका पूरा लाभ भी लक्ष्य समूह को मिलता है।</p>
            </div>
          </div>
        </InfoCard>
        </div>

        {/* 2 */}
        <div className="border border-tertiary bg-secondary-light flex flex-col gap-8 p-4 rounded-xl">
        <div className="text-2xl font-semibold">संस्था द्वारा संचालित कार्यक्रम एवं परियोजनाएं:-</div>
        <div>
            <h1 className='text-xl font-semibold pb-2'>शहरी साक्षरता कार्यक्रम:-</h1>
            <p className="indent-8">शहरी साक्षरता कार्यक्रम संस्था की स्थापना के साथ आरंभ हुआ। यह कार्यक्रम शिक्षा विभाग, राजस्थान सरकार द्वारा स्वीकृत एवं शिक्षा विभाग से 80 प्रतिशत अनुदानित था। शेष 20 प्रतिशत शेयर संस्था वहन करती थी। इस कार्यक्रम में प्रतिवर्ष 19 केन्द्रों का संचालन किया गया। जिसमें बीकानेर जिले की कच्ची बस्तियों में रह रहे दलित एवं उपेक्षित वर्ग के युवक-युवतियों को आत्मनिर्भरता से जोड़ा गया। जिसके तहत विभिन्न आकार के व्यावसायिक आशिक्षण केन्द्र, महिला साक्षरता केन्द्र, शिल्प साक्षरता केन्द्र, संगीत नृत्य केन्द्र एवं वाचनालय आदि केन्द्रों का संचालन किया गया। जिनका मकसद उपेक्षित वर्ग के समुन्नयन के लिए शिक्षा व रोजगार को बढ़ावा देने के साथ-साथ उनके व्यक्तित्व का सर्वांगीण विकास करना रहा। यह कार्यक्रम संस्था की स्थापना से फरवरी 2011 तक निरंतर संचालित रहा उसके पश्चात राजस्थान सरकार के नियमोंनुसार इस अनुदानित संस्थाओं के कार्मिकों को सरकारी उपक्रमों में समायोजित कर लिया गया।</p>
          </div>
          <div className="space-y-6"></div>

          <div className="space-y-6">

            <InfoCard title='व्यापक साक्षरता जन अभियान के तहत "पदयात्रा":'>
              जनसहभागिता के बिना हर अभियान अधूरा रह जाता है। संस्था द्वारा साक्षरता को घर-घर तक पहुँचाने और साक्षरता अभियान को गाँव-गाँव, ढाणी-ढाणी तक पहुँचाने और उसमें व्यापक जनसहभागिता जुटाने के उद्देश्य से व्यापक जनसाक्षरता अभियान चलाया गया। इस अभियान में मुख्य भूमिका निभाई – सजन पदयात्रा ने। 5 जून से 24 जून, 1989 तक 30 प्रेरक मुख्यालयों, और 300 प्रेरक शिक्षा केन्द्रों पर और 28 जून से 30 जून तक 24 गाँवों के सौ प्रेरक शिक्षा केन्द्रों तक सामूहिक पदयात्रा की गई। इस अभियान के लिए किसी प्रकार का बैनर, पेम्पलेट आदि विज्ञापनों का सहारा नहीं लेकर पदयात्रा कार्यक्रम का साहित्य एक पम्फलेट तैयार कर वितरित किया गया। इसके वितरण के लिए प्रभात फेरी, सांस्कृतिक कार्यक्रमों, नुक्कड़ नाटकों आदि के माध्यम से सजन पदयात्रा का वातावरण तैयार किया गया। जून महीने की तपती गर्मी भी कार्यकर्ताओं और ग्रामीणों का उत्साह कम नहीं कर पाई। समिति के पदाधिकारियों, कार्यकर्ताओं, स्थानीय स्वयंसेवकों सहित लगभग 400 लोग 25 दिनों तक एक गाँव से दूसरे गाँव और इसी तरह अगले गाँव तक बढ़ते रहे और साक्षरता की अलख जगाते रहे। पदयात्रा में गाँवों के निवासियों द्वारा अपने गाँवों में पदयात्रियों के लिए आवास व भोजन की व्यवस्था करने का उत्साह आज भी हमें प्रेरणा देता है। इसी तरह तत्कालीन जिला कलेक्टर मदनलाल गुप्ता भी पदयात्रियों की निरंतर खैर-खबर लेते रहे।
            </InfoCard>

            <InfoCard title="सम्पूर्ण साक्षरता अभियान:">
              <p className="indent-8 pb-2">
              इस अभियान के तहत सन 1992 से 1994 तक में संस्था द्वारा लूणकरणसर तहसील के 144 गांवों के 15 से 45 आयुवर्ग के कुल 5814 निरक्षर महिला-पुरुषों ने तीनों प्रवेशिकाएं पूरी करके साक्षरता प्राप्त की। इस कार्य के तहत राष्ट्रीय साक्षरता मिशन द्वारा तय साक्षरता मानकों – श्री आर-आर-आर थ्योरी के आधारपर पढ़ना, लिखना और गणना करने की योग्यता का स्तर प्राप्त करने के लिए व्यापक जन संपर्क और मजबूत रणनीति के साथ लक्ष्य को पूरा किया।
              </p>
              <p className="indent-8">
              यह अभियान अपनी व्यापक जन-सहभागिता और मजबूत टीम वर्क से लूणकरणसर तहसील के गांव-गांव और ढाणी-ढाणी तक आमजन की चर्चा का विषय बन गया था। निरक्षरों को अक्षरज्ञान कराने के लिए स्थानीय स्तर पर उपलब्ध सामग्री और अपने विशिष्ट तरीकों काम लिए गए नवाचारीपूर्ण और उत्साहजन थे।
              यथा : दैनिक जीवन में आने वाले उपकरणों को विभिन्न प्रकार के संकेत बनाकर ‘दिसुलियू’ के रूप में काम में लेना। इस अभियान का सफलता प्रतिशत 89.15 प्रतिशत रहा।
              </p>
            </InfoCard>
          </div>

          <InfoCard title="लोक जुम्बिश परियोजना:">
            <p className="indent-8">
            लोक जुंबिश परिषद, जयपुर के सौजन्य से संस्था द्वारा लोक जुंबिश परियोजना के तहत दिसम्बर 1992 से कार्य आरंभ किया गया था।
            इस परियोजना का मकसद 6 से 14 आयु वर्ग के बालक-बालिकाओं को जन सहभागिता के माध्यम से संतोषप्रद स्तर की प्राथमिक शिक्षा सुलभ कराना रहा। संस्था द्वारा लोक जुंबिश परियोजना के तहत <span className="font-semibold">लूणकरणसर तहसील के संकुल महाजन व अर्जुनसर तथा बीकानेर तहसील के संकुल जामसर व शेरों के 114 गांवों में </span>के लोगों को साक्षर करने का सतत कार्य किया गया।
            इस परियोजना का मुख्य उद्देश्य परियोजना क्षेत्र के सभी बालक-बालिकाओं के लिए प्राथमिक शिक्षा तक का अधिगम स्तर प्राप्त करवाना था।
            यह परियोजना जून 2004 तक संचालित की गई।
            </p>
          </InfoCard>
            
            <InfoCard title="आवासीय बालिका शिक्षण शिविरों का संचालन:">
              <p className="mb-3">
                संस्था द्वारा लोक जुम्बिश परियोजना के तहत ही ग्रामीण क्षेत्र में 6 से 14 आयु वर्ग की निरक्षर बालिकाओं को शिक्षा की मुख्यधारा से जोड़ने की पहल में 1997 से आवासीय बालिका शिक्षण शिविरों का सफल संचालन किया गया। गुणवत्तापूर्ण शिक्षा को बढ़ावा देने हेतु संस्थान ने कई आवासीय बालिका शिक्षण शिविर संचालित किए। इन शिविरों के अनुभवों से संस्था के अनुभवी संदर्भ व्यक्ति, प्रशिक्षित शिक्षिकाएं एवं कार्यकर्ताओं की अच्छी टीम ने समर्पित भावना से शिविरों को सफल बनाया। इन शिविरों के लिए संस्था ने अपने स्तर पर पाठ्यक्रम निर्माण एवं सहायक शिक्षण सामग्री निर्माण कार्य में एक नई पहल की है। संस्था द्वारा फ़िल्मी दृष्टि परियोजना के तहत भी कई बालिका शिक्षण आवासीय शिक्षण शिविर संचालित किए गए।
              </p>
              <p>
                इन शिविरों की सबसे बड़ी उपलब्धि यह रही कि जिन-जिन क्षेत्रों में ये शिविर आयोजित किए गए, उन क्षेत्रों और उनके आस-पास के क्षेत्रों के स्कूलों में बालिकाओं का नामांकन विशेष रूप से बढ़ा। तत्पश्चात वर्तमान तक उन क्षेत्रों में स्कूल-कॉलेज भी पर्याप्त मात्रा में खुले हैं।
              </p>


              <div className="p-5 rounded-xl shadow mb-6">
                <h3 className="font-semibold mb-2">गृह उद्योग परियोजना:</h3>
                <p className="indent-4">
                  इस परियोजना के तहत संस्था द्वारा सामाजिक, आर्थिक एवं शैक्षिक दृष्टि से पिछड़ी एवं वंचित महिलाओं की आत्मनिर्भरता के लिए, कौशल विकास कार्यक्रमों का संचालन किया गया। जिनके माध्यम से लक्ष्य समूह की महिलाओं को रोजी-रोटी कमाने लायक बनाया गया। उल्लेखनीय है कि संस्था ने उद्योग निर्देशनालय, जयपुर से अनुमोदित घर उद्योग परियोजना की 1974 में शुरुआत से लेकर परियोजना संचालित रहने तक 2005 तक संस्था ने निरंतर इस परियोजना का संचालन किया।
                </p>
              </div>

              <div className="p-5 rounded-xl shadow mb-6">
                <h3 className="font-semibold mb-2">अनौपचारिक शिक्षा:</h3>
                <p className="indent-4">
                  अनौपचारिक शिक्षा से तात्पर्य है कि ऐसी शिक्षा व्यवस्था जिसमें किसी प्रकार की औपचारिकता का प्रवेश न हो। समिति ने 1974 से 1991 तक अनौपचारिक एवं अनवरत शिक्षा परियोजना के माध्यम से 17 वर्षों में 24270 लोगों को लाभान्वित किया।
                </p>
              </div>

              <div className="p-5 rounded-xl shadow mb-6">
                <h3 className="font-semibold mb-2">जन शिक्षण संस्थान:</h3>
                <p className="indent-4">
                  साक्षर होने के बाद व्यक्ति पुनः निरक्षरता की ओर न चला जाए, साक्षरता का स्तर यथावत रहे। इसी क्रम में 1989-1993 तक संस्था द्वारा राष्ट्रीय शिक्षा नीति के तहत गाँवों में जन शिक्षण संस्थान के रूप में साक्षरता केन्द्र स्थापित किए गए। जन शिक्षण संस्थान गाँव की चौपाल का वह अनूठा स्थान माना गया जहां स्वास्थ्य, खेल-कूद, कृषि-पशुपालन, ऊर्जा संरक्षण, उद्योग आदि सभी आवश्यकताएं एक स्थान पर पूरी हो जाएं। समिति ने 1989-1993 की अवधि में चार वर्षों तक यह कार्यक्रम चलाया। इसके तहत बीकानेर और लूणकरणसर के 30 गाँवों में 32840 लोगों को लाभान्वित किया गया।
                </p>
              </div>

              <div className="p-5 rounded-xl shadow mb-6">
                <h3 className="font-semibold mb-2">ग्रामीण क्रियाशील साक्षरता कार्यक्रम:</h3>
                <p className="indent-4">
                  इस कार्यक्रम के तहत 15-35 आयुवर्ग के वंचित महिला-पुरुषों को साक्षरता से जोड़ने के लिए, राष्ट्रीय साक्षरता मिशन के तहत 600 प्रौढ़ शिक्षा केन्द्रों को संचालित करने की अनुमति प्राप्त हुई। इसके तहत लूणकरणसर एवं बीकानेर तहसील के 150 गाँवों में 600 प्रौढ़ शिक्षा केन्द्रों के माध्यम से 116198 लोगों को लाभान्वित किया गया।
                </p>
              </div>

              <div className="p-5 rounded-xl shadow mb-6">
                <h3 className="font-semibold mb-2">पशुपालन आधारित व्यावहारिक साक्षरता परियोजना:</h3>
                <p className="indent-4">
                  ग्रामीण क्षेत्रों में पशुपालन कौशल अभिवृद्धि की दृष्टि से संचालित इस परियोजना में 1975-1980 तक 100 केन्द्रों के माध्यम से 14820 पशुपालकों को लाभान्वित किया गया।
                </p>
              </div>
            </InfoCard>

            
          <InfoCard title="किशोर आयु वर्ग के लिए शिक्षा और विकास कार्यक्रम:">
            <p className="indent-8">
              श्री दोराबजी टाटा ट्रस्ट, मुम्बई के सौजन्य से संस्था द्वारा किशोर आयु वर्ग के लिए शिक्षा और विकास कार्यक्रम "किशोर दृष्टि" का संचालन जून, 2010 से 2013 तक किया गया। इस कार्यक्रम के माध्यम से बीकानेर पंचायत समिति की 13 ग्राम पंचायतों के 50 गाँवों में 11 से 20 आयु वर्ग के किशोर एवं किशोरियों को प्राथमिक शिक्षा, जीवन कौशल शिक्षा उपलब्ध कराने एवं ग्राम स्तर पर महिला मंच एवं युवा मंच तैयार करने का कार्य किया गया। इसके साथ ही कार्यक्रम के तहत 30 प्रेरणा केन्द्रों, छः बालिका शिक्षा हेतु आवासीय शिक्षण शिविरों एवं जीवन कौशल प्रशिक्षण शिविरों का आयोजन किया गया।
            </p>


          <div className="space-y-6 mt-6">
            <div className="p-5 rounded-xl shadow mb-6">
              <h2 className="text-xl font-semibold mb-2">जन शिक्षण संस्थान, बीकानेर:</h2>

              <p className="indent-4 pb-2">
                <span className="font-semibold">भारत सरकार के कौशल विकास एवं उद्यमिता मंत्रालय </span>
                के सौजन्य से 
                <span className="font-semibold">बीकानेर प्रौढ़ शिक्षण समिति, बीकानेर </span>
                द्वारा जनवरी, 2001 से 
                <span className="font-semibold">जन शिक्षण संस्थान, बीकानेर </span>
                का संचालन किया जा रहा है।
              </p>

              <p className="indent-4 pb-2">
                <span className="font-semibold">जन शिक्षण संस्थान, बीकानेर की स्थापना सन् 2001-02 में हुई। भारत सरकार के कौशल विकास एवं उद्यमिता मंत्रालय </span>
                के सौजन्य से संचालित 
                <span className="font-semibold">जन शिक्षण संस्थान, बीकानेर </span>
                का मुख्य उद्देश्य बीकानेर जिले के शहरी एवं ग्रामीण क्षेत्रों के 
                <span className="font-semibold">निरक्षर, नवसाक्षर, अल्पशिक्षित तथा आर्थिक, सामाजिक एवं वंचित वर्ग के लोगों को व्यावसायिक कौशल एवं जीवन संवर्धन शिक्षा में दक्ष कर उन्हें आत्मनिर्भर एवं आर्थिक रूप से स्वावलंबी बनाना है। </span>
                जिससे वे राष्ट्रीय सरोकार की दिशा में अपने उत्तरदायित्व का निर्वाह कर विकास की मुख्यधारा में अमर्यद हो सकें। जन शिक्षण संस्थान की पृष्ठभूमि के तहत उल्लेखनीय है कि सन् 1965 में राष्ट्रीय साक्षरता मिशन, स्कूल शिक्षा एवं साक्षरता विभाग, मानव संसाधन विकास मंत्रालय, भारत सरकार द्वारा 
                <span className="font-semibold">श्रमिक विद्यापीठ </span>
                के नाम से इस स्कीम की शुरुआत वर्ली, मुंबई से की गई। सन् 2000 से इसका नाम श्रमिक विद्यापीठ से 
                <span className="font-semibold">जन शिक्षण संस्थान </span>
                कर दिया गया।
              </p>

              <p className="indent-4 pb-2">
                उल्लेखनीय है कि भारत सरकार द्वारा 
                <span className="font-semibold">जनवरी, 2018 </span>
                से देश के सभी 
                <span className="font-semibold">जन शिक्षण संस्थानों </span>
                को मानव संसाधन विकास मंत्रालय से 
                <span className="font-semibold">कौशल विकास एवं उद्यमिता मंत्रालय में स्थानांतरित </span>
                कर दिया गया।
              </p>

              <p className="indent-4 pb-2">
                <span className="font-semibold">जन शिक्षण संस्थान, बीकानेर </span>
                द्वारा अब तक संचालित 
                <span className="font-semibold">60 प्रकार के विभिन्न पाठ्यक्रमों </span>
                में अब तक निर्धारित 
                <span className="font-semibold">लक्ष्य समूह के 37443 </span>
                महिला-पुरुषों को विभिन्न कौशल प्रशिक्षणों से लाभान्वित किया गया है।
              </p>

              <h2 className="text-xl font-bold mt-6 mb-3">संस्था की नियमित गतिविधियां :</h2>
              <p className="indent-4 pb-4">
                संस्था द्वारा शिक्षा, स्वास्थ्य एवं रोजगार उन्नयन के लिए विभिन्न परियोजनाओं के साथ संस्था स्तर पर सामाजिक एवं राष्ट्रीय सरोकार के तहत कुछ नियमित गतिविधियां भी संचालित की जाती हैं। यथा :
              </p>

              <h3 className="text-lg font-semibold mb-2">मेजर जनरल जयदेव सिंह भार्गव स्मृति विचारपीठ :</h3>
              <p className="indent-4 pb-4">
                समिति के संस्थापक अध्यक्ष मेजर जनरल जयदेवसिंह भार्गव की स्मृति में 1983 में गठित विचारपीठ के तहत समसामयिक विषयों पर व्याख्यान, विचारगोष्ठियां, संवाद कार्यक्रम का नियमित आयोजन किया जाता रहा है। विचारपीठ का उद्देश्य शहरी तथा ग्रामीण क्षेत्रों में समसामयिक विषयों पर विश्लेषणात्मक मंथन लोकतंत्रता में जनभागीदारी सुनिश्चित करना है।
              </p>

              <h3 className="text-lg font-semibold mb-2">डाॅ. छन्नामोेता स्मृति व्याख्यानमाला :</h3>
              <p className="indent-4 pb-2">
                समिति के संस्थापक सदस्य एवं पूर्व अध्यक्ष मनीषी डाॅ. छन्ना मोेता की स्मृति में आयोजित व्याख्यानमाला समिति का एक महत्वपूर्ण कार्यक्रम है। डाॅ. छन्नामोेता प्रौढ़ शिक्षा के जीवंत प्रतीक और बहुआयामी व्यक्तित्व थे। 1987 से प्रारंभ इस व्याख्यानमाला में अब तक 18 व्याख्यान संपन्न हो चुके हैं। व्याख्यानमाला की शुरुआत इतिहासवेत्ता धर्मपाल के व्याख्यान से हुई थी। 
              </p>
              <p className="indent-4 pb-2">
                इस व्याख्यानमाला में अब तक विचारक रमेशचंद्र शाह, अर्थशास्त्री प्रो. विजयर शंकर व्यास, दर्शनशास्त्री प्रो. चाैदमल, कवि-आलोचक अशोक वाजपेयी, समाजशास्त्री रामाश्रय राय, शिक्षाशास्त्री ऋण कुमार, कवि-चिंतक डाॅ. नंदकिशाेर आचार्य, पत्रकार राजकिशोर, रंगमंच नेमीचंद जैन, शिक्षाविद् अनिल बोर्दिया, कवि गिरधर राठी, अधिष्ठाता तेरापंथ धर्मसंघ आचार्य श्रीमहाश्रमण, कला समीक्षक विजयशंकर, इस्लाम अध्येता प्रो. अक्तरूल वासे, कथालेखक मुकुल लाठ एवं साहित्य-आलोचक डाॅ. पुरुषोत्तम अग्रवाल एवं शायर शीन काफ निजाम के मर्मभेदी व्याख्यानों ने विशेष आकर्षण प्रदान किया है।
              </p>
            </div>
          </div>
          </InfoCard>

          <InfoCard title="आत्मनिर्भरता की राह में कौशल विकास प्रशिक्षणों का प्रभावी संचालन :">
          <p className="indent-8 text-justify leading-relaxed mb-4">
            संस्था द्वारा समय समय पर विभिन्न परियोजनाएं संचालित की जाती रही हैं। जिनके तहत शहरी कच्ची 
            बस्तियों एवं ग्रामीण क्षेत्रों में गरीबी रेखा से नीचे जीवन यापन कर रहे जरूरतमंद व कमजोर वर्ग के युवक-युवतियों 
            को रोजगार मिला है। संस्था द्वारा शैक्षिक आयोजक व सामाजिक क्षेत्र के कमजोर वर्ग को हाथ का हुनर सिखाकर 
            आजीविका उपार्जन करना का अवसर दिया जाता है। जिनमें मुख्य रूप से संस्था द्वारा संचालित विभिन्न परियोजनाएं 
            <span className="font-semibold"> यूथ स्किल परियोजना उद्योग विभाग राजस्थान सरकार जयपुर </span>
            (सौजन्य, जिला उद्योग केंद्र, बीकानेर) <span className="font-semibold">दर्जी जूती 
            शर्ट बेगार योजना </span>(सौजन्य, नगर निगम, बीकानेर), <span className="font-semibold">सीमेंट 
            क्षेत्र विकास कार्यक्रम </span>(सौजन्य-जिला परिषद, बीकानेर) 
            व <span className="font-semibold">राजस्थान कौशल एवं आजीविकक विकास निगम, जयपुर एवं जन 
            शिक्षण संस्थान, बीकानेर </span>जैसी विभिन्न 
            परियोजनाओं के माध्यम से जिला स्तर पर कौशल प्रशिक्षण संचालित किये जाते रहे हैं।
          </p>

          <div className="p-4 rounded-lg mb-4">
            <p className="font-semibold mb-2 flex items-start">
              <span className="mr-2">▶</span>
              राजस्थान नॉलेज कॉरपोरेशन लिमिटेड, जयपुर(RKCL) की ओर से RS-CIT कोर्स
            </p>
            <p className="indent-4 text-justify leading-relaxed">
              संस्था को आर.के.सी.एल. का अधिकृत ज्ञान केंद्र <span className="font-semibold">आर.एस.-सी.आई.टी. कोर्स </span>
              की मान्यता प्राप्त है। संस्था 
              परिसर में युवसुविधा कम्प्यूटर लेब के माध्यम से सरकारी नौकरी के लिए कम्प्यूटर ज्ञान के अनिवार्य प्रशिक्षण कोर्स
            </p>
            <p className="text-justify leading-relaxed">
              <span className="font-semibold">RKCL </span>से <span className="font-semibold">RS-CIT </span>
              कोर्स कराया जाता है। जिले भर के बेरोजगार एवं जरूरतमंद युवक-युवतियों को इस 
              प्रशिक्षण कोर्स का लाभ मिल रहा है।
            </p>
          </div>

          <div className="p-4 rounded-lg mb-4">
            <p className="font-semibold mb-2 flex items-start">
              <span className="mr-2">▶</span>
              स्वनिर्धा पोषित कौशल प्रशिक्षण कार्यक्रम :-
            </p>
            <p className="indent-4 text-justify leading-relaxed mb-3">
              संस्था द्वारा अब तक विभिन्न सरकारी एवं गैरसरकारी परियोजनाओं के तहत जिले भर में विभिन्न 
              प्रकार के कौशल प्रशिक्षण केन्द्रों का संचालन किया जाता रहा है। इन प्रशिक्षणों में लक्ष्य समूह से संबंधित 
              विभिन्न प्रकार की बाध्यताओं एवं मानदंडों के चलते बहुत से युवा व युवतियां इन प्रशिक्षणों में प्रवेश नहीं ले 
              पाते थे।
            </p>
            <p className="indent-4 text-justify leading-relaxed mb-3">
              इसलिए सोचा गया कि संस्था द्वारा अपने स्तर पर ही समुदाय की मांग को देखते हुए कौशल 
              प्रशिक्षणों का संचालन हो - जिससे समाज के हर वर्ग के लिए कौशल प्रशिक्षणों की उपलब्धता बन सके - 
              इसके बारे में सोचा गया। इसी सोच के फलस्वरूप संस्था द्वारा <span className="font-semibold">स्वनिर्धा पोषित कौशल प्रशिक्षणों </span>के माध्यम से 
              - <span className="font-semibold">सिलाई, फैशन डिजाइनिंग, ब्यूटी एंड हेल्थ केयर, मेहंदी-रंगोली, कम्प्यूटर बेसिक, कम्प्यूटर एकाउंटिंग </span>आदि 
              प्रकार के मांग आधारित प्रशिक्षणों का संचालन किया जा रहा है।
            </p>
            <p className="indent-4 text-justify leading-relaxed">
              इस कार्य में संगीता द्वारा <span className="font-semibold">आयुर्वेदिक - रेमेडी एवं अरोमा </span>का प्रशिक्षण भी संचालित किया जा रहा है। 
              इस प्रशिक्षण के द्वारा युवतियों को उत्तराखंड रोजगार की मिलती है। इस प्रशिक्षण की प्रतियोगी परीक्षाओं की 
              तैयारी कराते हुए उनको आत्मनिर्भर बनाने से अपने उत्पाद के अपसरण हेतु समूहों का निर्माण किया जा रहा है।
            </p>
          </div>

          <div className="p-4 rounded-lg mb-4">
            <p className="font-semibold mb-2 flex items-start">
              <span className="mr-2">▶</span>
              हुनर हाट बना स्वावलंबन का आधार :-
            </p>
            <p className="indent-4 text-justify leading-relaxed mb-3">
              बीकानेर श्रेष्ठ शिक्षण समिति परिसर में नगर निगम, बीकानेर के आर्थिक सहयोग से निर्मित 
              <span className="font-semibold"> हुनर-हाट </span>में संगीता द्वारा विभिन्न कौशल प्रशिक्षण में प्रशिक्षित महिलाएं अपने हुनर को बाजार से जोड़कर 
              आजीविका स्वावलंबन प्राप्त करने लगी हैं। इसमें मुख्य रूप से राजस्थानी भोजन और शुद्ध घरेलू व्यंजनों के लिए हुनर हाट चर्चित 
              <span className="font-semibold"> एक ट्रेनिंग सेंटर </span>का भी सफलतापूर्वक संचालन किया जा रहा है।
            </p>
          </div>
        </InfoCard>
        </div>

        <div className="border border-tertiary bg-secondary-light flex flex-col gap-8 p-4 rounded-xl">
          <InfoCard title="कोरोना काल में समिति द्वारा सामाजिक उत्तरदायित्व का निर्वाह :-">
            <p className="indent-8 pb-2">
              <span className="font-semibold">समिति ने कोरोना वायरस कोविड-19 वैश्विक महामारी </span>के बचाव एवं सुरक्षा के लिए बीकानेर जिले के शहरी एवं ग्रामीण क्षेत्रों में जमीनी स्तर पर जन-जागरूकता के लिए सार्थक कार्य किए गए। इस क्रम में संस्थान द्वारा शहरी कच्ची बस्तियों एवं ग्रामीण क्षेत्रों में कोरोना महामारी से बचाव के लिए आमजन को सजग एवं जागृत करते हुए <span className="font-semibold">आवश्यक सावधानियों एवं बचाव के उपायों की जानकारियां दी गईं। </span>इसके साथ संस्थान द्वारा दिए गए कच्चे माल से संस्थान की <span className="font-semibold">महिला सदस्य व्यक्तियों एवं प्रशिक्षुओं द्वारा निःशुल्क मास्क तैयार किए गए और उनका निःशुल्क वितरण किया गया।</span>
            </p>
            <p className="indent-8">
              <span className="font-semibold">कोरोना जागृति कार्यक्रमी के तहत निःशुल्क मास्क वितरण, निःशुल्क सैनेटाइजर वितरण, कोरोना योद्धाओं का सम्मान, सूचना एवं जनसम्पर्क कार्यालय के सहयोग से 7 दिवसीय जिलास्तरीय कोरोना जागृति प्रदर्शनी तत्पश्चात् इस प्रदर्शनी का ब्लॉक स्तर पर आयोजन जैसी गतिविधियों के माध्यम से संस्था ने अपनी सामाजिक सरोकार की भूमिका का प्रभावी रूप से निर्वहन किया।</span>
            </p>
          </InfoCard>
        </div>

        <h1 className="font-bold text-2xl pt-8 text-center">बीकानेर प्रौढ़ शिक्षण समिति, बीकानेर</h1>
        <h1 className="font-bold text-2xl text-center">वर्तमान कार्यकारिणी समिति:</h1>
          <table className="min-w-[80%] border-collapse border border-primary table-fixed bg-primary-light rounded-sm mx-auto">
              <thead>
                <tr className="bg-primary-dark text-background">
                  <th className="border border-primary text-center py-2 px-2">क्र.</th>
                  <th className="border border-primary py-2 px-4">नाम</th>
                  <th className="border border-primary py-2 px-4">विवरण</th>
                  <th className="border border-primary py-2 px-4">पद</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-primary p-2 text-center">1.</td>
                  <td className="border border-primary p-2">श्रीमती सुशीला ओझा</td>
                  <td className="border border-primary p-2">शिक्षाविद् एवं समाजसेविका</td>
                  <td className="border border-primary p-2">कार्यकारी अध्यक्ष एवं उपाध्यक्ष</td>
                </tr>
                <tr>
                  <td className="border border-primary p-2 text-center">2.</td>
                  <td className="border border-primary p-2">डॉ. ओम कुवेरा</td>
                  <td className="border border-primary p-2">शिक्षाविद् एवं समाजसेवी</td>
                  <td className="border border-primary p-2">मानद सचिव</td>
                </tr>
                <tr>
                  <td className="border border-primary p-2 text-center">3.</td>
                  <td className="border border-primary p-2">डॉ. केदार शर्मा</td>
                  <td className="border border-primary p-2">चिकित्सक एवं शिक्षाविद्</td>
                  <td className="border border-primary p-2">संयुक्त सचिव एवं कोषाध्यक्ष</td>
                </tr>
                <tr>
                  <td className="border border-primary p-2 text-center">4.</td>
                  <td className="border border-primary p-2">श्रीमती कमला कोचर</td>
                  <td className="border border-primary p-2">महिला प्रतिनिधि</td>
                  <td className="border border-primary p-2">सदस्य</td>
                </tr>
                <tr>
                  <td className="border border-primary p-2 text-center">5.</td>
                  <td className="border border-primary p-2">श्री ओम सोनी</td>
                  <td className="border border-primary p-2">उद्योग एवं वाणिज्य प्रतिनिधि</td>
                  <td className="border border-primary p-2">सदस्य</td>
                </tr>
                <tr>
                  <td className="border border-primary p-2 text-center">6.</td>
                  <td className="border border-primary p-2">डॉ.चन्द्रशेखर रंगा</td>
                  <td className="border border-primary p-2">व्यावसायिक प्रतिनिधि</td>
                  <td className="border border-primary p-2">सदस्य</td>
                </tr>
                <tr>
                  <td className="border border-primary p-2 text-center">7.</td>
                  <td className="border border-primary p-2">श्री राजेन्द्र जोशी</td>
                  <td className="border border-primary p-2">कार्यक्रम उपसमिति -प्रबंध, वित्त एवं संसाधन</td>
                  <td className="border border-primary p-2">संयोजक</td>
                </tr>
                <tr>
                  <td className="border border-primary p-2 text-center">8.</td>
                  <td className="border border-primary p-2">एडवोकेट गिरिराज मोहता</td>
                  <td className="border border-primary p-2">विधि सलाहकार प्रतिनिधि</td>
                  <td className="border border-primary p-2">संयोजक</td>
                </tr>
                <tr>
                  <td className="border border-primary p-2 text-center">9.</td>
                  <td className="border border-primary p-2">प्राचार्य</td>
                  <td className="border border-primary p-2">रामपुरिया विधि महाविद्यालय, बीकानेर</td>
                  <td className="border border-primary p-2">पदेन</td>
                </tr>
                <tr>
                  <td className="border border-primary p-2 text-center">10</td>
                  <td className="border border-primary p-2">अतिरिक्त शिक्षा निदेशक</td>
                  <td className="border border-primary p-2">प्रारंभिक शिक्षा, राजस्थान, बीकानेर</td>
                  <td className="border border-primary p-2">पदेन</td>
                </tr>
                <tr>
                  <td className="border border-primary p-2 text-center">11.</td>
                  <td className="border border-primary p-2">प्राचार्य</td>
                  <td className="border border-primary p-2">एस.पी.मेडिकल कॉलेज, बीकानेर</td>
                  <td className="border border-primary p-2">पदेन</td>
                </tr>
                <tr>
                  <td className="border border-primary p-2 text-center">12.</td>
                  <td className="border border-primary p-2">प्राचार्य</td>
                  <td className="border border-primary p-2">राजकीय पॉलिटेक्निक कॉलेज, बीकानेर</td>
                  <td className="border border-primary p-2">पदेन</td>
                </tr>
                <tr>
                  <td className="border border-primary p-2 text-center">13.</td>
                  <td className="border border-primary p-2">अध्यक्ष</td>
                  <td className="border border-primary p-2">प्रधानाध्यापक वार्कशॉप, बीकानेर</td>
                  <td className="border border-primary p-2">पदेन</td>
                </tr>
                <tr>
                  <td className="border border-primary p-2 text-center">14.</td>
                  <td className="border border-primary p-2">डॉ.नंदकिशोर आचार्य</td>
                  <td className="border border-primary p-2">समिति के पूर्व अध्यक्ष - कवि-चिंतक</td>
                  <td className="border border-primary p-2">विशेष आमंत्रित सदस्य</td>
                </tr>
              </tbody>
            </table>
      </div>
    </div>
  );
};

export default Educommittee;